import React, { useState, useMemo } from "react";
import DataTable from "components/DataTable";
import PageWrapper from "components/PageWrapper";
import { useTableData } from "../../hooks/useTableData";
import { bbpsReportConfig } from "config/tableConfigs";
import { useSession } from "hooks/useSession";

const BBPSReportsPage = () => {
  const { userid, role } = useSession();
   const userRole = role === "Platform User" ? "Admin" : role;
  const [loading] = useState(false);

  const getLast7Days = () => {
    const today = new Date();
    const last7 = new Date();
    last7.setDate(today.getDate() - 1)  ;
  
    return {
      start: last7.toISOString().split("T")[0],
      end: today.toISOString().split("T")[0],
    };
  };
  
 const getTodayRange = () => {
  const today = new Date();
  const todayStr = today.toISOString().split("T")[0];
  return {
    start: todayStr,
    end: todayStr,
  };
};

const { start, end } = getTodayRange();

  const [apiUrl, setApiUrl] = useState(
    `https://pro.mokshiq.in/bbps_report_data?user=${userid}&filter_date=${start}&end_date=${end}`
  );

  const tableData = useTableData(apiUrl, 0, bbpsReportConfig);

  const handleDateFilter = (s, e) => {
    setApiUrl(
      `https://pro.mokshiq.in/bbps_report_data?user=${userid}&filter_date=${s}&end_date=${e}`
    );
  };

  const filteredConfig = useMemo(() => {
    const base = {
      ...bbpsReportConfig,
      columns: [...bbpsReportConfig.columns],
    };

    const roleMap = {
      Retailer: [
        "id",
        "txn_id",
        "operator",
        "product",
        "number",
        "amount",
        "created_at",
        "status",
        "Opening Balance BC",
        "BC Commission",
        "tds",
        "Closing Balance BC",
      ],

      "API Partner": [
        "id",
        "txn_id",
        "operator",
        "product",
        "number",
        "amount",
        "created_at",
        "status",
        "Opening Balance BC",
        "BC Commission",
        "tds",
        "Closing Balance BC",
        "api_response"
      ],

      Distributer: [
        "id",
        "txn_id",
        "operator",
        "product",
        "number",
        "amount",
        "created_at",
        "status",
        "commission Dist",
        "tds Dist",
      ],

      "Super Distributer": [
        "id",
        "txn_id",
        "operator",
        "product",
        "number",
        "amount",
        "created_at",
        "status",
        "commission SuperDist",
        "tds SuperDist",
      ],
      "White label": [
        "id",
        "BC Name",
        "Phone",
        "txn_id",
        "operator",
        "product",
        "number",
        "amount",
        "status",
        "Opening Balance",      // Maps to WL Opening Balance
        "Commission",           // Maps to WL Commission
        "TDS",                  // Maps to WL TDS
        "Charge",               // Maps to WL Charge
        "GST",                  // Maps to WL GST
        "Closing Balance",      // Maps to WL Closing Balance
        "Opening Balance BC",   // Maps to Agent's Opening
        "BC Commission",        // Maps to Agent's Profit
        "tds",                  // Maps to Agent's TDS
        "Closing Balance BC",   // Maps to Agent's Closing
        "created_at",
      ],

      Admin: [
        "id",
        "BC Name",
        "Phone",
        "txn_id",
        "operator",
        "product",
        "number",
        "amount",
        "created_at",
        "status",
        "Opening Balance Admin",
        "Commission Admin",
        "TDS Admin",
        "Charge Admin",
        "GST Admin",
        "Closing Balance Admin",
        "Opening Balance BC",
        "BC Commission",
        "tds",
        "Closing Balance BC",
        "Wallet Txn",
        "TXN ID",
        "Transection Flow",
      ],

      "Main Admin": base.columns.map((c) => c.key),
    };

    const allowedKeys = roleMap[userRole] || [];
    base.columns = base.columns.filter((c) =>
      allowedKeys.includes(c.key)
    );

    return base;
  }, [userRole]);

  return (
    <div>
      {loading && (
        <div className="page-loader-overlay d-flex justify-content-center align-items-center">
          <div className="spinner-border text-primary" />
        </div>
      )}

      <PageWrapper
        config={bbpsReportConfig}
        onDateFilter={handleDateFilter}
      >
        <DataTable
          config={filteredConfig}
          tableData={tableData}
          onView={() => {}}
          onEdit={() => {}}
          onDelete={() => {}}
          onExport={() => {}}
          onDeleteSelected={() => {}}
        />
      </PageWrapper>
    </div>
  );
};

export default BBPSReportsPage;
